import dayjs from 'dayjs';

import plugin from 'dayjs/plugin/advancedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

const CURRENT_YEAR = new Date().getFullYear();

const formatUs = (date: Date | undefined) => {
    if (date) {
        return dayjs(date).format('MM/DD/YYYY');
    } else {
        return dayjs().format('MM/DD/YYYY');
    }
};

const today = () => {
    return new Date();
};

const yesterday = () => {
    return dayjs().subtract(1, 'day').toDate();
};

const tomorrow = () => {
    return dayjs().add(1, 'day').toDate();
};

const isFutureTimestamp = (date: string) => {
    const currentTimestamp = dayjs();
    const expirationTimestamp = dayjs(date);

    return currentTimestamp.isBefore(expirationTimestamp);
};

const formatPayroll = (date: string) => {
    dayjs.extend(plugin);
    return dayjs(date).format('dddd, MMMM Do, YYYY');
};

const formatEffectivefirstPayroll = (date: string | undefined) => {
    if (date) {
        return dayjs(date).format('MMM D, YYYY');
    } else {
        return dayjs().format('MMM D, YYYY');
    }
};

const formatDateISO = (date: Date | undefined) => {
    if (date) {
        return dayjs(date).format('YYYYMMDD');
    } else {
        return dayjs().format('YYYYMMDD');
    }
};

const fromNow = (date?: Date) => {
    if (date) {
        dayjs.extend(relativeTime);
        return dayjs(date).fromNow();
    }

    return '';
};

const firstDayofMonth = (date?: Date) => {
    if (date) {
        return dayjs(date).startOf('month').format('YYYY-MM-DD');
    }
    return '';
};

const isWeekday = (date: Date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6;
};

const formatNotificationDate = (date: Date | undefined) => {
    if (date) {
        return dayjs(date).format('MMM D YYYY');
    } else {
        return dayjs().format('MMM D YYYY');
    }
};

const currentServerTimestamp = () => {
    dayjs.extend(utc)
    dayjs.extend(timezone)
    return dayjs().tz("America/New_York").format()
}

const currentServerTime = () => {
    dayjs.extend(utc)
    dayjs.extend(timezone)
    return dayjs().tz("America/New_York").format('HH:mm:ss');
}

const safeDateParse = (dateValue: string | Date | undefined): Date | string => {
    if (!dateValue) return '';
    
    if (dateValue instanceof Date) {
        return dateValue;
    }

    if (typeof dateValue === 'string') {
        if (/^\d{8}$/.test(dateValue)) {
            const year = dateValue.substring(0, 4);
            const month = dateValue.substring(4, 6);
            const day = dateValue.substring(6, 8);
            const parsedDate = new Date(`${year}-${month}-${day}T12:00:00`);
            return isNaN(parsedDate.getTime()) ? '' : parsedDate;
        }
        
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
            const parsedDate = new Date(`${dateValue}T12:00:00`);
            return isNaN(parsedDate.getTime()) ? '' : parsedDate;
        }
        
        const parsedDate = new Date(dateValue);
        return isNaN(parsedDate.getTime()) ? '' : parsedDate;
    }
    
    return '';
};

export {
    CURRENT_YEAR,
    today,
    yesterday,
    isFutureTimestamp,
    formatUs,
    formatPayroll,
    formatDateISO,
    formatEffectivefirstPayroll,
    fromNow,
    firstDayofMonth,
    isWeekday,
    formatNotificationDate,
    currentServerTimestamp,
    currentServerTime,
    tomorrow,
    safeDateParse
};
